import { useToast as _toast } from 'vue-toastification'

const toastCallback = (cb, timer) => {
  setTimeout(cb, timer)
}

const ERROR_TOAST_DEDUPE_MS = 400
let lastErrorToastMessage = null
let lastErrorToastAt = 0

function shouldSkipDuplicateErrorToast(msg) {
  if (!msg) {
    return false
  }

  const now = Date.now()
  const isDuplicate = msg === lastErrorToastMessage && now - lastErrorToastAt < ERROR_TOAST_DEDUPE_MS

  if (!isDuplicate) {
    lastErrorToastMessage = msg
    lastErrorToastAt = now
  }

  return isDuplicate
}

const resolveToastArgs = (cbOrOptions, timer = TOAST_TIMER) => {
  if (cbOrOptions && typeof cbOrOptions === 'object' && typeof cbOrOptions !== 'function') {
    const options = {
      timeout: cbOrOptions.timeout ?? timer,
      ...cbOrOptions,
    }
    return { cb: undefined, options }
  }

  return {
    cb: typeof cbOrOptions === 'function' ? cbOrOptions : undefined,
    options: { timeout: timer },
  }
}

export const useToast = () => {
  const toast = _toast()

  const show = (type, msg, cbOrOptions, timer = TOAST_TIMER) => {
    const { cb, options } = resolveToastArgs(cbOrOptions, timer)
    if (options.id != null) {
      toast.dismiss(options.id)
    }
    toast[type](msg, options)
    if (cb) toastCallback(cb, options.timeout)
  }

  return {
    success: (msg, cbOrOptions, timer = TOAST_TIMER) => {
      show('success', msg, cbOrOptions, timer)
    },
    error: (msg, cbOrOptions, timer = TOAST_TIMER) => {
      if (shouldSkipDuplicateErrorToast(msg)) {
        return
      }
      show('error', msg, cbOrOptions, timer)
    },
    warning: (msg, cbOrOptions, timer = TOAST_TIMER) => {
      show('warning', msg, cbOrOptions, timer)
    },
    info: (msg, cbOrOptions, timer = TOAST_TIMER) => {
      show('info', msg, cbOrOptions, timer)
    },
    dismiss: id => toast.dismiss(id),
    clear: () => toast.clear(),
  }
}
